import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import _ from 'lodash';
import * as eChartProxy from '../../eChartProxy';
import Row from '../../../basic/row';
import Col from '../../../basic/col';
import * as tabsactions from 'yxyweb/common/redux/tabs';
import moment from 'moment';
import * as treeactions from 'yxyweb/common/redux/tree';

export class eChartWaittingTask extends Component {

  constructor (props) {
    super(props);
    let config = props.panelWaittingTaskConfig;
    this.trimCondition(config.taskArray);
    this.state = {
      taskColNum: config.taskColNum,
      taskArray: config.taskArray
    }
  }

  componentDidMount () {
    // displayName,
    // taskId: cb.utils.getNewGuid(),
    // taskName: "",
    // taskBillNum: "",
    // taskFilterId: "",
    // taskSolutionId: "",
    // taskCondition: {}
    let self = this;
    this.state.taskArray.forEach((ele) => {
      self.getData(ele);
    })

  }



  getData = (ele) => {
    let self = this;
    let callback = (json) => {
      let count = 0;
      let taskArray = self.state.taskArray;
      let ele2 = _.findLast(taskArray, function (o) { return o.taskId == ele.taskId })
      if (ele2) {
        if (json.code == 200 && json.data && json.data.recordCount) {
          count = json.data.recordCount;
        }
        ele2.taskCount = count;
        this.setState({ taskArray });
      }
    }
    let params = {
      billnum: ele.taskBillNum,  //: "rm_retailvouchlist"
      condition: ele.taskCondition,
      page: { pageSize: 1, pageIndex: 1, totalCount: -1 }
    }
    // eChartProxy.doProxy(eChartProxy.url.reportList, 'POST', eChartCommon.trimCondition(_.cloneDeep(queryParams), self.state.sumConfig.predicateValue), callback);
    eChartProxy.doProxy(eChartProxy.url.reportList, 'POST', params, callback);

  }
  trimCondition (taskArray) {
    taskArray && taskArray.forEach((task) => {
      let commonVOs = task.taskCondition && task.taskCondition.commonVOs;
      if (commonVOs) {
        for (let i = commonVOs.length - 1; i >= 0; i--) {
          let ele = commonVOs[i];
          if (ele.hasOwnProperty("predicateValue")) {
            if (ele.predicateValue == "0") {
              ele.value1 = moment().add(0, 'day').format('YYYY-MM-DD 00:00:00');
              ele.value2 = moment().add(0, 'day').format('YYYY-MM-DD 23:59:59');
            }
            else if (ele.predicateValue == "-1") {
              ele.value1 = moment().add(-1, 'day').format('YYYY-MM-DD 00:00:00');
              ele.value2 = moment().add(-1, 'day').format('YYYY-MM-DD 23:59:59');
            }
            else {
              ele.value1 = moment().add(parseInt(ele.predicateValue) + 1, 'day').format('YYYY-MM-DD 00:00:00');
              ele.value2 = moment().add(0, 'day').format('YYYY-MM-DD 23:59:59');
            }
            delete ele.predicateValue;
          }
          let hasValue = false;
          if (ele.hasOwnProperty("value1") && ele.value1 !== null && ele.value1 !== "")
            hasValue = true;
          if (ele.hasOwnProperty("value2") && ele.value2 !== null && ele.value2 !== "")
            hasValue = true;
          if (hasValue == false) {
            commonVOs.splice(i, 1);
          }
        }
      }
    })

  }
  executeTask (item) {
    let self = this;
    console.log(JSON.stringify(item));
    // cb.utils.alert(JSON.stringify(item), 'warning');
    // if (this.props.isInDesign == false && this.props.triggerObj && this.props.triggerObj.clickEvent) {

    if (this.props.triggerObj && this.props.triggerObj.clickEvent) {

      let params = {};
      params.billnum = item.taskBillNum;
      params.menu_code = item.taskMenuCode;
      params.billName = item.taskName;
      params.condition = item.taskCondition;
      if (params.condition)
        params.condition.isWaittingTask = true;
      const { tabsactions, tabs } = this.props;
      let taskMenuCode = item.taskMenuCode;
      let pane = _.find(tabs.panes, function (o) { return o.key == taskMenuCode });
      if (pane) {
        tabsactions.deleteItem(taskMenuCode);
        setTimeout(() => {
          self.props.triggerObj.clickEvent(params);
        }, 100)
      }
      else {
        self.props.triggerObj.clickEvent(params);
      }
    }

  }
  findMenuEle = (TreeData, taskMenuCode) => {
    let obj;
    if (TreeData && TreeData.length) {
      TreeData.forEach((ele) => {
        if (ele.code.toLowerCase() == taskMenuCode.toLowerCase()) {
          obj = obj || ele;
        }
        else if (ele.children) {
          let tmp = this.findMenuEle(ele.children, taskMenuCode);
          obj = obj || tmp;
        }
        else {
          return undefined;
        }
      })
    }
    return obj;
  }
  render () {
    let self = this;
    let taskArray = this.state.taskArray;
    let taskColNum = this.state.taskColNum;
    let content = [];
    let children = [];
    let menuTree = this.props.tree;
    taskArray.forEach((item, index) => {
      let menuEle = self.findMenuEle(menuTree && menuTree.TreeData, item.taskMenuCode);
      if (_.isEmpty(menuEle) == false && children.length < taskColNum) {
        children.push(<Col className="clsWaittingTask_Col"
          span={1} onClick={() => self.executeTask(item)} >
          <div className="clsWaittingTask_Value">{item.taskCount} </div>
          <div className="clsWaittingTask_Caption">{item.displayName}</div>
        </Col>)
      }
      if (children.length == taskColNum || index == taskArray.length - 1) {
        content.push(<Row
          className="clsWaittingTask_Row"
          style={{ width: '100%' }}
          colCount={taskColNum}>
          {children}
        </Row>);
        children = [];
      }
    });

    return (
      <div className="clsWaittingTask_Outer">
        <div className="clsWaittingTask_Title" >
          我的待办
        </div>
        <div className="clsWaittingTask_Content" >
          {content}
        </div>
      </div>);

  }

}



function mapStateToProps (state) {
  return {
    tree: state.tree.toJS(),
    tabs: state.tabs.toJS(),
  }
}

function mapDispatchToProps (dispatch) {
  return {
    treeactions: bindActionCreators(treeactions, dispatch),
    tabsactions: bindActionCreators(tabsactions, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(eChartWaittingTask);


// WEBPACK FOOTER //
// ./src/yxyweb/common/components/echart/panel/component/eChartWaittingTask.jsx